import { render, staticRenderFns } from "./SymptomList.vue?vue&type=template&id=1463ee6c&scoped=true&"
import script from "./SymptomList.vue?vue&type=script&lang=js&"
export * from "./SymptomList.vue?vue&type=script&lang=js&"
import style0 from "./SymptomList.vue?vue&type=style&index=0&id=1463ee6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463ee6c",
  null
  
)

export default component.exports